export default __webpack_public_path__ + "static/media/Cammeron1.d3395a8e.png";